import React from "react";
import Slider from "react-slick";
import "../Styles/client.css";
import afmc from "../../Assets/afmc.png";
import vigilant from "../../Assets/vigilant.jfif";
import osi from "../../Assets//osi.jpg";
import alloys from "../../Assets/alloys.jpg";
import Adtech from "../../Assets/adtech.jpg";
import enroc from "../../Assets/encroc.jfif";
import saksoft from "../../Assets/saksoft.jfif";

const Clients = () => {
  const clients = [
    {
      id: 1,
      name: "AFMC",
      image: afmc,
      description: "Armed Forces Medical College"
    },
    {
      id: 2,
      name: "Adtech",
      image: Adtech,
      description:
        "Delivers custom software and innovative digital solutions worldwide."
    },
    {
      id: 3,
      name: "Enroc",
      image: enroc,
      description:
        "A trusted ERP partner with expertise in Oracle Cloud ERP implementation "
    },
    {
      id: 4,
      name: "Saksoft",
      image: saksoft,
      description:
        "Global digital transformation company focused on analytics, automation, and cloud"
    },
    {
      id: 5,
      name: "Vigilant",
      image: vigilant,
      description:
        "A trusted partner delivering agile Oracle solutions for measurable business impact.  "
    },
    {
      id: 6,
      name: "Alloys",
      image: alloys,
      description:
        "Specialist distributor driving business growth through value-added solutions."
    },
    {
      id: 7,
      name: "OSI",
      image: osi,
      description:
        "Global business and technology solutions provider specializing in accelerated digital transformation."
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div className="clients-container">
      <h3 className="hTitle">Our Clients</h3>
      <p>We offer a wide range of services to help you succeed.</p>
      <Slider {...settings} className="clients-carousel">
        {clients.map(client =>
          <div key={client.id} className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img
                  src={client.image}
                  alt={client.name}
                  className="client-img"
                />
              </div>
              <div className="flip-card-back">
                <h3 className="client-name">
                  {client.name}
                </h3>
                <p className="client-description">
                  {client.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </Slider>
    </div>
  );
};

export default Clients;
